module.exports = __webpack_public_path__ + "img/banner_job.9574dd30.jpg";